export default __webpack_public_path__ + "static/media/0063.f6cb65cf.jpg";